var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.currentItem && _vm.currentItem.dId
    ? _c(
        "el-col",
        {
          class: _vm.className,
          attrs: { id: _vm.currentItem.dId, span: _vm.config.span },
        },
        [
          _vm.currentItem.typeId === "SUB_FORM"
            ? [
                _c(
                  "div",
                  {
                    staticClass: "batch-box",
                    on: {
                      click: function ($event) {
                        return _vm.emitEvent("activeItem", _vm.currentItem)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "batch-label" }, [
                      _vm._v(" " + _vm._s(_vm.currentItem.config.label) + " "),
                      _c("span", { staticClass: "desc-text" }, [
                        _vm._v("需拖拽组件到这里子表单生效"),
                      ]),
                    ]),
                    _c(
                      "draggable",
                      _vm._b(
                        {
                          staticClass: "draggable-box",
                          attrs: {
                            id: _vm.currentItem.formId,
                            list: _vm.currentItem.childList,
                            move: _vm.handleMove,
                            draggable: ".drag-move",
                            tag: "div",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.handleChange($event, _vm.currentItem)
                            },
                          },
                        },
                        "draggable",
                        {
                          group: _vm.insertAllowed ? "componentsGroup" : "",
                          ghostClass: "moving",
                          animation: 180,
                          handle: ".drag-move",
                        },
                        false
                      ),
                      [
                        _c(
                          "transition-group",
                          { staticClass: "list-main", attrs: { tag: "div" } },
                          _vm._l(
                            _vm.currentItem.childList,
                            function (child, index) {
                              return _c(
                                "div",
                                {
                                  key: child.vModel,
                                  staticClass: "drag-move",
                                  class:
                                    _vm.activeId === child.config.formId
                                      ? "active-from-item"
                                      : "",
                                  on: {
                                    click: function (event) {
                                      _vm.activeChildItem(
                                        event,
                                        child,
                                        index,
                                        _vm.currentItem
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("form-item", {
                                    key: child.renderKey,
                                    staticClass: "form-item",
                                    attrs: {
                                      "current-item": child,
                                      index: index,
                                    },
                                  }),
                                  _c("div", { staticClass: "drawing-list" }, [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "drawing-item__primary",
                                        attrs: { title: "复制" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.copyChildItem(child)
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-copy-document",
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "drawing-item__delete",
                                        attrs: { title: "删除" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteChildItem(index)
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-delete",
                                        }),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              )
                            }
                          ),
                          0
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "drawing-list" }, [
                  _c(
                    "span",
                    {
                      staticClass: "drawing-item__primary move",
                      attrs: { title: "移动" },
                    },
                    [_c("i", { staticClass: "el-icon-rank" })]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "drawing-item__primary copy",
                      attrs: { title: "复制" },
                      on: {
                        click: function ($event) {
                          return _vm.emitEvent(
                            "copyItem",
                            _vm.currentItem,
                            _vm.drawingList,
                            $event
                          )
                        },
                      },
                    },
                    [_c("i", { staticClass: "el-icon-copy-document" })]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "drawing-item__delete",
                      attrs: { title: "删除" },
                      on: {
                        click: function ($event) {
                          return _vm.emitEvent(
                            "deleteItem",
                            _vm.currentItem,
                            _vm.drawingList,
                            $event
                          )
                        },
                      },
                    },
                    [_c("i", { staticClass: "el-icon-delete" })]
                  ),
                ]),
              ]
            : [
                _c("form-item", {
                  key: _vm.currentItem.renderKey,
                  staticClass: "form-item",
                  attrs: {
                    "current-item": _vm.currentItem,
                    index: _vm.index,
                    "active-id": _vm.activeId,
                  },
                  on: {
                    change: function ($event) {
                      return _vm.emitEvent("change", _vm.currentItem)
                    },
                    "upload-option-img": function ($event) {
                      return _vm.emitEvent("uploadImg", _vm.currentItem)
                    },
                  },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.emitEvent(
                        "activeItem",
                        _vm.currentItem,
                        _vm.drawingList,
                        $event
                      )
                    },
                  },
                }),
                _c(
                  "div",
                  { staticClass: "drawing-list" },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "drawing-item__primary move",
                        attrs: { title: "移动" },
                      },
                      [_c("i", { staticClass: "el-icon-rank" })]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "drawing-item__primary copy",
                        attrs: { title: "复制" },
                        on: {
                          click: function ($event) {
                            return _vm.emitEvent(
                              "copyItem",
                              _vm.currentItem,
                              _vm.drawingList,
                              $event
                            )
                          },
                        },
                      },
                      [_c("i", { staticClass: "el-icon-copy-document" })]
                    ),
                    ["CHECKBOX", "RADIO"].includes(_vm.currentItem.typeId)
                      ? _c("el-tooltip", { attrs: { placement: "top" } }, [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [_vm._v("选项后填空")]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "drawing-item__primary",
                              attrs: { title: "选项后填空" },
                              on: {
                                click: function ($event) {
                                  return _vm.emitEvent(
                                    "addInputItem",
                                    _vm.currentItem,
                                    _vm.drawingList,
                                    $event
                                  )
                                },
                              },
                            },
                            [_c("i", { staticClass: "el-icon-tickets" })]
                          ),
                        ])
                      : _vm._e(),
                    _c(
                      "span",
                      {
                        staticClass: "drawing-item__delete",
                        attrs: { title: "删除" },
                        on: {
                          click: function ($event) {
                            return _vm.handleDel(
                              _vm.currentItem,
                              _vm.drawingList,
                              $event
                            )
                          },
                        },
                      },
                      [_c("i", { staticClass: "el-icon-delete" })]
                    ),
                  ],
                  1
                ),
              ],
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }